import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ContactTypeEnums } from 'src/app/enum/contact-type-enums';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { WalletManagementDetailTableModel } from 'src/app/models/tables/wallet/wallet-management-detail-table.model';
import { WalletManagementModel } from 'src/app/models/wallet/wallet-management.model';
import { ClientService } from 'src/app/services/archive/client.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { WalletManagementDetailService } from 'src/app/services/wallet/wallet-management-detail.service';
import { WalletManagementService } from 'src/app/services/wallet/wallet-management.service';
import { ContactReferenceModalComponent } from 'src/app/views/archive/contact-reference-modal/contact-reference-modal.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-wallet-management',
  templateUrl: './register-wallet-management.component.html',
  styleUrls: ['./register-wallet-management.component.scss'],
  standalone: false
})
export class RegisterWalletManagementComponent implements OnInit {

  @ViewChild('clientContactModal') clientContactModalComponent?: CustomModalComponent | null = null;
  ascendant: boolean = true;
  branchId: number = 0;
  columnSort: string | null = null;
  componentContactModal = ContactReferenceModalComponent;
  detailData: PagedResponseModel<WalletManagementDetailTableModel> = new PagedResponseModel<WalletManagementDetailTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledForm: boolean = false;
  disableSendButton: boolean = false;
  enterpriseId: number = 0;
  formWalletManagement: FormGroup = new FormGroup({});
  inputsForContactModals$ = new BehaviorSubject<any>({
    entityId: 0,
    isContact: false,
    typeContact: ContactTypeEnums.client
  });
  icon: string = '';
  isOpened: string | undefined = undefined;
  limit: number = 10;
  listBranches: any[] = [];
  listClients: any[] = [];
  listEnterprises: any[] = [];
  nameWindow: string = 'Captura Gestión Cartera';
  page: number = 1;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = 'success';
  stateWalletManagement: string = '';
  stateWalletManagementType: string = '';
  titleState: string = '';
  url: string = 'wallet-management';
  visibleList: boolean = false;
  walletManagementContract: WalletManagementModel = new WalletManagementModel();
  walletManagementId: number = 0;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private cdr: ChangeDetectorRef,
    private clientService: ClientService,
    private dateConverterService: DateConverterService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private walletManagementDetailService: WalletManagementDetailService,
    private walletManagementService: WalletManagementService,
    private windowService: WindowService) {
    this.validateForm(this.walletManagementContract);
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.walletManagementId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number, loadAll: boolean) {
    this.branchId = branchId;
    await this.getFirstEnterpriseByBranch();
    if (loadAll) {
      await this.getAllLists('enterprises');
      this.resetContract(branchId, this.enterpriseId);
    } else {
      await this.getAllLists();
    }
  }

  async changeConsecutive(consecutive: number) {
    this.branchId = this.formWalletManagement.get("branchId")?.value;
    this.enterpriseId = this.formWalletManagement.get("enterpriseId")?.value;
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    if (!consecutive) {
      this.resetContract(this.branchId, this.enterpriseId);
      return;
    }
    try {
      const response = await firstValueFrom(this.walletManagementService.getWalletManagementByConsecutive(this.branchId, consecutive));
      this.walletManagementId = response.walletManagementId;
      this.walletManagementContract = response;
      this.validateForm(this.walletManagementContract);
      this.location.replaceState(`/${this.url}/register/${this.walletManagementId}`);
    } catch (error) {
      this.resetContract(this.branchId, this.enterpriseId);
      console.error('Error al buscar la gestión de cartera.', error);
    }
  }

  async changeStateWalletManagement() {
    const { walletManagementId } = this.walletManagementContract;
    if (!walletManagementId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una gestión de cartera.');
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado de la gestión de cartera.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    try {
      const response = await firstValueFrom(this.walletManagementService.setStateWalletManagement(walletManagementId));
      this.walletManagementContract = response;
      this.validateForm(this.walletManagementContract);
      const successMessage = response.active ? 'La gestión de cartera fue abierta exitosamente.'
        : 'La gestión de cartera fue cerrada exitosamente.';
      this.toastHandlerService.showToast('success', successMessage);
    } catch (error) {
      console.error('Error al cambiar el estado la gestión de cartera.', error);
    }
  }

  async createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear una gestión de cartera.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    this.resetContract(this.branchId, this.enterpriseId);
  }

  async createWalletManagement(model: WalletManagementModel) {
    try {
      const response = await firstValueFrom(this.walletManagementService.createWalletManagement(model));
      this.walletManagementId = response.walletManagementId;
      this.walletManagementContract = response;
      this.validateForm(this.walletManagementContract);
      this.location.replaceState(`/${this.url}/register/${this.walletManagementId}`);
      this.toastHandlerService.showToast('success', `La gestión de cartera fue creada exitosamente.`);
    } catch (error) {
      console.error('Error al crear la gestión de cartera.', error);
    }
  }

  async createWalletManagementDetail() {
    if (!this.walletManagementContract.active) {
      this.toastHandlerService.showToast('warning', `La gestión de cartera esta cerrada.`);
    } else {
      const confirm = await Swal.fire({
        title: 'Atención',
        text: '¿Realmente desea cargar la cartera?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
      });
      if (confirm.isConfirmed) {
        try {
          await firstValueFrom(this.walletManagementDetailService.createWalletManagementDetail(this.walletManagementId));
          await this.getWalletManagementById();
          this.validateForm(this.walletManagementContract);
          this.toastHandlerService.showToast('success', `La cartera fue cargada exitosamente.`);
        } catch (error) {
          console.error('Error al crear el detalle de la cartera', error);
        }
      }
    }
  }

  async deleteWalletManagement() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar la gestión de cartera.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!this.walletManagementId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una gestión de cartera.');
      return;
    }
    const result = await Swal.fire({
      title: 'Atención',
      text: '¿Realmente desea eliminar la gestión de cartera?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.walletManagementService.deleteWalletManagement(this.walletManagementId));
        this.createNewRegister();
        this.toastHandlerService.showToast('success', 'La gestión de cartera fue eliminada exitosamente.');
      } catch (error) {
        console.error('Error al eliminar la gestión de cartera.', error);
      }
    }
  }

  async deleteWalletManagementDetail() {
    if (!this.walletManagementContract.active) {
      this.toastHandlerService.showToast('warning', `La gestión de cartera esta cerrada.`);
    } else {
      const confirm = await Swal.fire({
        title: 'Atención',
        text: '¿Realmente desea eliminar la cartera?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
      });
      if (confirm.isConfirmed) {
        try {
          await firstValueFrom(this.walletManagementDetailService.deleteWalletManagementDetail(this.walletManagementId));
          await this.getWalletManagementById();
          this.validateForm(this.walletManagementContract);
          this.toastHandlerService.showToast('success', 'La cartera fue eliminada exitosamente.');
        } catch (error) {
          console.error('Error al eliminar el detalle de la cartera', error);
        }
      }
    }
  }

  async editWalletManagement() {
    await this.getWalletManagementById();
    await this.changeBranch(this.walletManagementContract.branchId, false);
    this.validateForm(this.walletManagementContract);
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'enterprises' | 'clients'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranches = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
        },
        enterprises: async () => {
          this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
        },
        clients: async () => {
          this.listClients = await firstValueFrom(this.clientService.getAllClientsForSelectAsync());
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.enterprises(),
          lists.clients()
        ]);
      }
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    this.branchId = this.formWalletManagement.get("branchId")?.value;
    this.enterpriseId = this.formWalletManagement.get("enterpriseId")?.value;
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    await this.handleWalletManagementNavigation(buttonClick, this.branchId, this.enterpriseId)
  }

  async getColumnsForDetailCapture() {
    try {
      if (this.detailHeader.length === 0) {
        this.detailHeader = await firstValueFrom(this.walletManagementDetailService.getColumnsForDetailCapture());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para los detalles de la gestión de cartera.', error);
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      if (!response.branchId) {
        this.branchId = 0;
        return;
      }
      this.branchId = response.branchId;
      await this.getFirstEnterpriseByBranch();
      await this.getAllLists();
    } catch (error) {
      this.branchId = 0;
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getFirstEnterpriseByBranch() {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(this.branchId));
      if (!response) {
        this.enterpriseId = 0;
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene empresas creadas.');
        return;
      };
      this.enterpriseId = response.enterpriseId;
    } catch (error) {
      console.error('Error al obtener la primera empresa por sucursal.', error);
    }
  }

  async getPermission() {
    await this.getPermissionProfileByUrl();
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getWalletManagementById() {
    try {
      const response = await firstValueFrom(this.walletManagementService.getWalletManagementById(this.walletManagementId));
      this.walletManagementContract = response
    } catch (error) {
      console.error('Error al obtener la gestión de cartera por id.', error);
    }
  }

  async getWalletManagementDetailsForCaptureTable() {
    try {
      this.detailData = await firstValueFrom(this.walletManagementDetailService.getWalletManagementDetailsForCaptureTable(this.page,
        this.limit, this.columnSort, this.ascendant, this.walletManagementContract.walletManagementId));
      this.quantityDetails = this.detailData.totalItems;
    } catch (error) {
      console.error('Error al buscar los detalles de la gestión de cartera.', error);
    }
  }

  async handleDetailCapture() {
    try {
      await Promise.all([
        this.getColumnsForDetailCapture(),
        this.getWalletManagementDetailsForCaptureTable()
      ]);
    } catch (error) {
      console.error('Error al obtener la captura de detalles.', error);
    }
  }

  async handleInitialState() {
    if (this.walletManagementId) {
      await this.editWalletManagement();
    } else {
      await this.getFirstBranchByUserAuthenticated();
      this.createNewRegister();
    }
  }

  async handleWalletManagementNavigation(buttonClick: any, branchId: number, enterpriseId: number) {
    const consecutive = this.formWalletManagement.get("consecutive")?.value;
    const actionMap: Record<string, () => Promise<WalletManagementModel>> = {
      first: () =>
        firstValueFrom(this.walletManagementService.getFirstWalletManagementByKeys(branchId)),
      previus: () =>
        firstValueFrom(this.walletManagementService.getPreviusWalletManagementByKeys(branchId, consecutive)),
      next: () =>
        firstValueFrom(this.walletManagementService.getNextWalletManagementByKeys(branchId, consecutive)),
      last: () =>
        firstValueFrom(this.walletManagementService.getLastWalletManagementByKeys(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetContract(branchId, enterpriseId);
      return;
    }
    try {
      const walletManagement = await action();
      this.walletManagementId = walletManagement.walletManagementId;
      this.walletManagementContract = walletManagement;
      this.validateForm(this.walletManagementContract);
      this.location.replaceState(`/${this.url}/register/${this.walletManagementId}`);
    } catch (error) {
      console.error(`Error al buscar la gestión de cartera (${buttonClick.target.id}).`, error);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getWalletManagementDetailsForCaptureTable();
  }

  openContactModal() {
    if (this.walletManagementContract.clientId) {
      this.inputsForContactModals$.next({
        entityId: this.walletManagementContract.clientId,
        typeContact: ContactTypeEnums.client,
        isContact: true
      });
      this.clientContactModalComponent && this.clientContactModalComponent.show();
    } else {
      this.toastHandlerService.showToast('warning', `Debe seleccionar un cliente.`);
    }
  }

  async send() {
    this.validateFormControls();
    if (!this.walletManagementContract.active) {
      this.toastHandlerService.showToast('warning', `La gestión de cartera está cerrada.`);
      return;
    }
    if (!this.formWalletManagement.valid) {
      this.showValidationMessages();
      return;
    }
    const modelWalletManagement = this.formWalletManagement.getRawValue() as WalletManagementModel;
    if (this.walletManagementId === 0) {
      await this.createWalletManagement(modelWalletManagement);
    } else {
      await this.updateWalletManagement(modelWalletManagement);
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'Debe seleccionar una Sucursal.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      enterpriseId: {
        required: 'Debe seleccionar una Empresa.',
        min: 'Debe seleccionar una Empresa válida.'
      },
      clientId: {
        required: 'Debe seleccionar un Cliente.',
        min: 'Debe seleccionar un Cliente válido.'
      },
      dateWalletManagement: {
        required: 'Debe seleccionar una Fecha de Gestión de Cartera.'
      },
      contact: {
        required: 'Debe ingresar un Contacto.',
        minlength: 'El campo Contacto debe tener al menos 3 caracteres.',
        maxlength: 'El campo Contacto no puede tener más de 50 caracteres.'
      },
      observation: {
        minlength: 'El campo Observación debe tener al menos 3 caracteres.',
        maxlength: 'La Observación no puede tener más de 1000 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formWalletManagement.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async resetContract(branchId: number, enterpriseId: number) {
    this.walletManagementId = 0;
    this.walletManagementContract = new WalletManagementModel();
    this.walletManagementContract.branchId = branchId;
    this.walletManagementContract.enterpriseId = enterpriseId;
    this.validateForm(this.walletManagementContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  updateFormState() {
    const controlConsecutive = this.formWalletManagement.controls['consecutive'];
    const { quantityInvoices, active } = this.walletManagementContract;
    const isNewWalletManagement = this.walletManagementId === 0;
    const isEditable = active && quantityInvoices === 0;
    this.disableSendButton = !active;
    this.disabledForm = !active || isNewWalletManagement;
    this.titleState = active ? 'Cerrar' : 'Abrir';
    this.severityState = active ? 'success' : 'danger';
    this.icon = active ? 'pi pi-lock-open' : 'pi pi-lock';
    this.stateWalletManagement = active ? 'Abierto' : 'Cerrado';

    setTimeout(() => {
      if (active) {
        this.formWalletManagement.enable();
        if (isNewWalletManagement) {
          controlConsecutive.disable();
        } else {
          controlConsecutive.enable();
        }
      } else {
        this.formWalletManagement.disable();
        this.formControlStateService.setControlState(
          this.formWalletManagement,
          ['branchId', 'consecutive'],
          true
        );
      }
      this.formControlStateService.setControlState(
        this.formWalletManagement,
        ['clientId', 'enterpriseId'],
        isEditable
      );
      if (!this.permissionUpdatable) {
        this.formWalletManagement.disable();
        this.formControlStateService.setControlState(
          this.formWalletManagement,
          ['branchId', 'consecutive'],
          true
        );
      }
    });
  }

  async updateWalletManagement(model: WalletManagementModel) {
    this.walletManagementContract.enterpriseId = model.enterpriseId;
    this.walletManagementContract.clientId = model.clientId;
    this.walletManagementContract.dateWalletManagement = model.dateWalletManagement;
    this.walletManagementContract.contact = model.contact;
    this.walletManagementContract.observation = model.observation;
    try {
      const response = await firstValueFrom(this.walletManagementService.updateWalletManagement(this.walletManagementContract));
      this.walletManagementContract = response;
      this.validateForm(this.walletManagementContract);
      this.toastHandlerService.showToast('success', `La gestión de cartera fue modificada exitosamente.`);
    } catch (error) {
      console.error('Error al modificar la gestión de cartera.', error);
    }
  }

  async validateForm(walletManagement: WalletManagementModel) {
    this.formWalletManagement = this.formBuilder.group({
      branchId: [walletManagement.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [walletManagement.consecutive],
      enterpriseId: [walletManagement.enterpriseId, [Validators.required, Validators.min(1)]],
      clientId: [walletManagement.clientId, [Validators.required, Validators.min(1)]],
      dateWalletManagement: [walletManagement.dateWalletManagement ?
        this.dateConverterService.convertUtcToLocalDateFull(walletManagement.dateWalletManagement) : null, [Validators.required]],
      contact: [walletManagement.contact, [Validators.required, Validators.minLength(0), Validators.maxLength(50)]],
      observation: [walletManagement.observation, [Validators.minLength(0), Validators.maxLength(1000)],],
      active: [walletManagement.active]
    });
    await Promise.all([
      this.updateFormState(),
      this.handleDetailCapture(),
    ]);
  }

  validateFormControls() {
    Object.keys(this.formWalletManagement.controls).forEach((key) => {
      const control = this.formWalletManagement.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
